export default {"src":"/_next/static/media/san-diego-tribune.d4f74437.svg","height":167,"width":727,"blurWidth":0,"blurHeight":0};